import { useState } from "react";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import { Tooltip } from "reactstrap";
const ToggleButton = (props) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const setInsuranceVal = (val) => {
    props.setInsuranceVal(val);
  };
  return (
    <>
      <div className="text-center toogle-main mt-4 d-none">
        <h6
          style={{ cursor: "pointer" }}
          className={props.insurance == true ? "ins-true" : "ins-text"}
          onClick={(e) => {
            setInsuranceVal(true);
          }}
        >
          Save more with insurance
        </h6>

        <h6
          style={{ cursor: "pointer" }}
          className={props.insurance == false ? "ins-true" : "ins-text"}
          onClick={(e) => {
            setInsuranceVal(false);
          }}
        >
          100% out-of-pocket
        </h6>

        <>
          <span id="TooltipExample" className="info-tooltip d-none">
            <img src="/why_section/indo.webp" />
          </span>
          <Tooltip
            placement="top"
            isOpen={tooltipOpen}
            target="TooltipExample"
            toggle={toggle}
            style={{ width: "100%", wordBreak: "break-all" }}
          >
            If you have health insurance, you can use it at the lab. The price
            you pay with insurance includes your order for all tests, expedited
            results, unlimited messaging with a board certified doctor,
            prescription and treatment, and a doctor consultation post-testing
            if your results are abnormal. If you don't have insurance or don't
            want to use it, please select the out-of-pocket option. Next Medical
            passes on the costs of these tests 1:1 based on our nationally
            negotiated rates.
          </Tooltip>
        </>
      </div>
    </>
  );
};
export default ToggleButton;
